import { agreementsActivePage, publicAgreementsActivePage } from "../../../store/agreements";
import { casesActivePage } from "../../../store/cases";
import { formsActivePage, recordsActivePage } from "../../../store/data";
import { documentsActivePage } from "../../../store/documents";
import { refundsActivePage } from "../../../store/refunds";
import { simulationsActivePage } from "../../../store/simulator";
import { TableTypes } from "../LyfeDataTable";

export default function getActivePageByState(type: TableTypes) {
	switch (type) {
		case "forms":
			return formsActivePage;
		case "records":
			return recordsActivePage;
		case "cases":
			return casesActivePage;
		case "agreements":
			return agreementsActivePage;
		case "publicAgreements":
			return publicAgreementsActivePage;
		case "transactions":
			return refundsActivePage;
		case "documents":
			return documentsActivePage;
		case "simulations":
			return simulationsActivePage;
		default:
			throw new Error(`could not get ActivePage state from recoil store for ${type}.`);
	}
}
